import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getNotificationPreferences, updateNotificationPreferences } from './api';
import { NotificationPreferenceScope, NotificationPreferenceValues } from './types';

export const notificationPreferenceQueryKey = (scope: NotificationPreferenceScope, businessId: number | null) =>
  ['notification_preferences', scope, scope === 'business' ? businessId : null] as const;

export function useNotificationPreferences(scope: NotificationPreferenceScope, businessId: number | null) {
  return useQuery({
    queryKey: notificationPreferenceQueryKey(scope, businessId),
    queryFn: () => getNotificationPreferences(scope)
  });
}

export function useUpdateNotificationPreferences(scope: NotificationPreferenceScope, businessId: number | null) {
  const queryClient = useQueryClient();
  const queryKey = notificationPreferenceQueryKey(scope, businessId);

  return useMutation({
    mutationFn: (preferences: Record<string, NotificationPreferenceValues>) =>
      updateNotificationPreferences(scope, preferences),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, data);
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });
}
